/**
 * Element id the chart marks itself with so other components can cover exactly the chart's
 * area by portalling into it.
 *
 * It lives here rather than in either component because both ends need it and neither should
 * have to import the other: the chart is a large module and the right panel has no business
 * pulling it in just to read a string.
 */
export const CHART_OVERLAY_HOST_ID = 'chart-overlay-host';
